
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Toast } from 'vant';
import { formatNoticeHtml } from '@/utils/migrationNotice';

@Component({})
export default class MigrationBlock extends Vue {
  @Prop({ default: () => ({}) }) info!: any;

  redirectSeconds = 0;
  private redirectTimer = 0;

  get phase(): number {
    return Number(this.info.phase || 2);
  }
  get cutoverStart(): number {
    return Number(this.info.cutover_start || 0);
  }
  get cutoverEnd(): number {
    return Number(this.info.cutover_end || 0);
  }
  get noticeText(): string {
    return String(this.info.notice_text || '');
  }
  get noticeHtml(): string {
    return formatNoticeHtml(this.noticeText);
  }
  get schoolName(): string {
    const fromInfo = String(this.info.school_label || '');
    if (fromInfo) return fromInfo;
    const schoolConfig = (window as any).schoolConfig || {};
    return String(schoolConfig.schoolName || '');
  }
  get newPlatformUrl(): string {
    // 移动端优先用 mobile 地址，未配置则回退 PC 地址
    return String(this.info.new_platform_url_mobile || this.info.new_platform_url || '');
  }
  get autoJump(): boolean {
    return Number(this.info.done_jump_mode || 0) === 1;
  }

  mounted(): void {
    if (this.phase >= 3 && this.autoJump && this.newPlatformUrl) {
      this.redirectSeconds = 5;
      this.redirectTimer = window.setInterval(() => {
        this.redirectSeconds -= 1;
        if (this.redirectSeconds <= 0) {
          clearInterval(this.redirectTimer);
          this.gotoNewPlatform();
        }
      }, 1000);
    }
  }

  beforeDestroy(): void {
    if (this.redirectTimer) {
      clearInterval(this.redirectTimer);
    }
  }

  formatTime(ts: number): string {
    if (!ts) return '--';
    const d = new Date(ts * 1000);
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  async copyUrl(): Promise<void> {
    if (!this.newPlatformUrl) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(this.newPlatformUrl);
      } else {
        const input = document.createElement('input');
        input.value = this.newPlatformUrl;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      Toast.success('链接已复制，请妥善保存');
    } catch (e) {
      Toast.fail('复制失败，请手动选中地址复制');
    }
  }

  gotoNewPlatform(): void {
    if (this.newPlatformUrl) {
      window.location.href = this.newPlatformUrl;
    }
  }
}
